import { render, staticRenderFns } from "./BrandSite.vue?vue&type=template&id=67879612&scoped=true&"
import script from "./BrandSite.vue?vue&type=script&lang=js&"
export * from "./BrandSite.vue?vue&type=script&lang=js&"
import style0 from "./BrandSite.vue?vue&type=style&index=0&id=67879612&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67879612",
  null
  
)

export default component.exports